import React from 'react';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';

/** Step 1 — secure-payment notice, no-refund disclaimer, and "Proceed" CTA. */
export default function InitiatePaymentSection({ amount, processing, onInitiate }) {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 p-4 rounded-2xl flex items-start gap-3">
        <Lock className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-sm font-bold text-blue-900 mb-1">Secure Payment via Pocket Pay</p>
          <p className="text-xs text-blue-700">
            Your payment is processed securely through Pocket Pay gateway.
            Card payments only. Currency: BND (Brunei Dollar).
          </p>
        </div>
      </div>

      <div className="bg-muted/30 border border-border p-3 rounded-xl">
        <p className="text-xs text-muted-foreground text-center leading-relaxed">
          <strong className="text-foreground">No Refund Policy:</strong> All sales are final. We do not offer refunds, exchanges, or cancellations once payment has been processed.
        </p>
      </div>

      <Button
        onClick={onInitiate}
        disabled={processing}
        className="btn-primary w-full h-14 text-lg font-black"
        data-testid="initiate-payment-button"
      >
        {processing ? 'Initiating Payment...' : `Proceed to Payment - $${amount.toFixed(2)}`}
      </Button>
    </div>
  );
}
